var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "size": "md",
      "id": "modal-new-asset",
      "title": "Tambah Aset Baru"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": !_vm.isValidForm
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.submit($event);
            }
          }
        }, [_vm._v("Simpan")])];
      },
      proxy: true
    }])
  }, [_c('b-form-group', {
    staticClass: "mb-2",
    attrs: {
      "label": "Nama Aset"
    }
  }, [_c('b-form-input', {
    staticClass: "w-full",
    model: {
      value: _vm.form.nama,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nama", $$v);
      },
      expression: "form.nama"
    }
  })], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Jenis Aset"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 1,
        text: 'TETAP'
      }, {
        value: 2,
        text: 'BHP'
      }]
    },
    model: {
      value: _vm.form.jenis,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "jenis", $$v);
      },
      expression: "form.jenis"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Harga Dasar"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Harga Dasar"
    },
    on: {
      "keyup": _vm.doFormatRupiah
    },
    model: {
      value: _vm.form.harga_dasar,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "harga_dasar", $$v);
      },
      expression: "form.harga_dasar"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Kategori"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.kategoriOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text"
    },
    model: {
      value: _vm.form.id_kategori,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_kategori", $$v);
      },
      expression: "form.id_kategori"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Satuan"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.satuanOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text"
    },
    model: {
      value: _vm.form.id_satuan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_satuan", $$v);
      },
      expression: "form.id_satuan"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Jumlah"
    }
  }, [_c('b-form-input', {
    staticClass: "w-full",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "0 = stok masuk via penempatan pengadaan"
    },
    model: {
      value: _vm.form.jumlah,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "jumlah", $$v);
      },
      expression: "form.jumlah"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Isi 0 jika stok akan masuk lewat penempatan pengadaan.")])], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tanggal Aset"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Ex: ",
      "type": "date"
    },
    model: {
      value: _vm.form.tanggal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tanggal", $$v);
      },
      expression: "form.tanggal"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }